export enum FieldNames {
  Sites = 'sites',
  Sectors = 'sectors',
  Categories = 'categories',
  Reset = 'reset',
}
